import React from 'react';

const IconZIP = () => (
    <svg width="20px" height="20px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path fill="#3A3A3A" fillRule="nonzero" d="M7 0h23l13 13v37H7z" />
            <path fill="#000" fillRule="nonzero" d="M30 0l13 13H30z" />
            <path
                d="M33.315 31.566V34.4h3.776v1.888h-7.553v-1.888h2.833v-9.441h-2.833V23.07h7.553v1.888h-3.776v1.888h1.888v.944h-1.888v.944h1.888v.944h-1.888v.944h1.888v.944h-1.888zm-20.77-8.496v-1.888h16.993v1.888H12.545zm0 15.105v-1.888h16.993v1.888H12.545zm1.889-3.304V24.486H27.65v10.385H14.434z"
                fill="#FFF"
            />
        </g>
    </svg>
);

export default IconZIP;
